import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import { Link } from "react-router";

import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';

import Decoder from "../../../Token/Decoder";
import Token from "../../../Token/Token";

class ConfirmEmail extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_CHECK_EMAIL_CLEAR;

  constructor(public props) {
    super(props);

    this.updateEmail = this.updateEmail.bind(this);
    this.process = this.process.bind(this);
    this.onEnter = this.onEnter.bind(this);
  }

  /**
   * This is the hotfix for react-router issue, that cause the problem of
   * infinite rerendering of component: routeParams(received for react-router Route) props
   * updates few times per sec
   * 
   * TODO: Should be fixed by installing the new version of react-router-dom
   * */ 
   shouldComponentUpdate(newProps, nextState) {
    if (this.state !== nextState) return true;
    const isPropsStringsSame = JSON.stringify(newProps) === JSON.stringify(this.props)
    if (
      isPropsStringsSame
      && newProps.routeParams !== this.props.routeParams
    ) {
      return false;
    }

    return !isPropsStringsSame;
  }

  public componentWillMount() {
    const token = this.props.location?.query?.token;
    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_CONFIRM_START,
      payload: {
        token: token
      },
      onSuccess: () => {
        this.props.dispatch({
          type: Constants.POST_PROCESS_MESSAGE,
          payload: {
            postProcessMessage: this.trans("email-was-successfully-changed")
          }
        });

        const storageToken = Token.getInstant() && Decoder.decode(Token.getInstant());

        // If we are already logged in, ignore this page.
        if (!!storageToken && !storageToken.isExpired && this.props.app.loadedEntities.length > 0) {
          return this.redirect("/app/dashboard/overview");
        }
      }
    });
  }

  protected process() {
    this.props.dispatch({
      type: Constants.PAGE_CHECK_EMAIL_START,
      payload: {
        email: this.props.component.email
      }
    });
  }

  protected updateEmail(e) {
    this.props.dispatch({
      type: Constants.PAGE_CHECK_EMAIL_UPDATE_EMAIL,
      payload: {
        email: e.target.value
      }
    });
  }

  protected onEnter(event): any {
    if (event.key === "Enter") {
      return this.process();
    }
  }

  public render() {
    return (
      <div className="state-auth">
        <div className="box component-check-email">

          {this.props.component.signoutReason.length > 0 && <p>{this.props.component.signoutReason}</p>}

          <h1>Casadesk</h1>
          <h2>{this.trans("title-signin")}</h2>
          <p style={{color: "green"}}>{this.trans("email-was-successfully-changed")}</p>

          <form onSubmit={e => e.preventDefault()}>
            <TextField
              className="form-element"
              type="email"
              autoComplete="email"
              autoFocus={true}
              fullWidth={true}
              label={this.trans("label-email")}
              value={this.props.component.email}
              onKeyPress={this.onEnter}
              onChange={this.updateEmail}
              variant="standard"
              error={this.props.component.error === true ? !!this.props.component.message : false}
            />
            {!!this.props.component.message && <div className="component-error-text">{this.props.component.message}</div>}

            <Button
              variant="contained"
              color="primary"
              fullWidth={true}
              onClick={this.process}
              disabled={this.props.component.isFetching}
              style={{ margin: "20px 0" }}
            >
              {this.props.component.isFetching === true ? this.trans("button-please-wait") : this.trans("button-next")}
            </Button>

            <Link to="/auth/signup">
              {this.trans("link-signup")}
            </Link>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.checkEmail,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
    ConfirmEmail
);
